<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" scrollable>
			<v-card>
				<v-card-title class="text-h6">Form Registrasi Ulang</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Nama" v-model="params.name" @focus="() => error_validation.name = ''" :error-messages="error_validation.name"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Password" v-model="params.passwd" @focus="() => error_validation.passwd = ''" :error-messages="error_validation.passwd"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Sponsor" v-model="params.sponsor" @focus="() => error_validation.sponsor = ''" :error-messages="error_validation.sponsor"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Email" v-model="params.email" @focus="() => error_validation.email = ''" :error-messages="error_validation.email"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="No. Hp" v-model="params.mobilephone" @focus="() => error_validation.mobilephone = ''" :error-messages="error_validation.mobilephone"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="No. Identitas" v-model="params.identity_no" @focus="() => error_validation.identity_no = ''" :error-messages="error_validation.identity_no"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" :disabled="status !== 'pending'" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
	data () {
		return {
			params: {
				register_id: '',
				name: '',
				passwd: '',
				sponsor: '',
				email: '',
				mobilephone: '',
				identity_no: ''
			},
			status: '',
			dialog: false,
		}
	},
	props: {
	},
	computed: {
		...mapState(['error_validation']),
	},
	methods: {
		...mapMutations(['validationError']),

		showModal() {
			this.dialog = true
		},
		hideModal() {
			this.dialog = false
		},
		defineParams(data) {
			this.validationError({})
			this.params.register_id = data.register_id
			this.params.passwd = data.register_member_password
			this.params.name = data.register_member_name
			this.params.email = data.register_member_email
			this.params.identity_no = data.register_member_ktp
			this.params.mobilephone = data.register_member_phone
			this.params.sponsor = data.register_sponsor_code
			this.status = data.register_status
		},
		simpan(){
			this.$emit('resend', this.params)
		}
	},
	watch: {
	},
	created() {
	}
}
</script>
